<template>
    <section class="featured-categories-wrap container">
        <div class="container">
            <div class="featured-categories-header">
                <div class="featured-categories-text">
                    <h2 class="title" v-html="data.title"></h2>
                    <span class="excerpt">{{ data.subtitle }}</span>
                </div>

                <div class="row categorieshomepage">

                    <div v-for="(tab, index) in tabs" :key="index"   @click="handleTabClick(tab.url)" class="specialwidth">
                        <div class="cercle">
                             <div class="cercle-inner" :style="{ backgroundImage: 'url(' + tab.logo + ')' }"></div>
                        </div>
                        <span class="featured-category-name">{{ tab.label }}</span>
                    </div>






                </div>
            </div>

         
        </div>

        <dynamic-tab v-for="(category, index) in data.categories" :key="index" :urlbtn="category.url"  :urllink="category.urllink"   :label="category.name"
            :initial-logo="category.logo"
            :url="category.urllink">
        </dynamic-tab>

        <div align="center" style="margin-top:25px;">
            <a class="btn btn-primary btn-deals" id="GroupeCatProd" href="https://ucanbe.tn/fr/categories">Découvrir</a>
        </div>

    </section>
</template>

<script>
import ProductCard from '../ProductCard.vue';
import DynamicTabsMixin from '../../mixins/DynamicTabsMixin';
import { slickPrevArrow, slickNextArrow } from '../../functions';

export default {
    components: { ProductCard },

    mixins: [
        DynamicTabsMixin,
    ],

    props: ['data', 'flash'],
    mounted() {
        
    },

    computed: {
        dynamicWidth() {
            return `calc(100% / ${this.tabs.length})`;
        },
    },

    methods: {

      
        handleTabClick(tab) {
            document.location.href=tab;


        },
      

        selector() {
            return $('.featured-category-products');
        },

        slickOptions() {
            return {
                rows: 0,
                dots: true,
                arrows: true,
                infinite: true,
                autoplay: true,
                speed: 5000,
                autoplay_speed: 5000,
                slidesToShow: 6,
                slidesToScroll: 6,
                rtl: window.FleetCart.rtl,
                /* 
                prevArrow: slickPrevArrow(),
                nextArrow: slickNextArrow(), 
                */
                responsive: [
                    {
                        breakpoint: 1761,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 5,
                        },
                    },
                    {
                        breakpoint: 1301,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        },
                    },
                    {
                        breakpoint: 1051,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        },
                    },
                    {
                        breakpoint: 881,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 641,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                ],
            };
        },
    },
};
</script>
<style scoped>

.categorieshomepage .specialwidth {
    display: flex;
    flex: 1;
    width: var(--dynamic-width);
    box-sizing: border-box;
}

</style>